import clsx from 'clsx';
import { IGetTrafficSourcesDataFormatted } from '@api/types';
import useI18n from '@i18n/index';

import styles from '../styles.module.scss';

interface ITrafficButtonProps {
    source: IGetTrafficSourcesDataFormatted;
    selectedSourceId: string;
    onSelect: (id: string) => void;
}

const TrafficButton: React.FC<ITrafficButtonProps> = ({ source, selectedSourceId, onSelect }) => {
    const { locale } = useI18n();
    const showExtraSymbol: boolean = /Instagram|Facebook/.test(source.name) && locale === 'ru';

    return (
        <button
            className={clsx(styles.source, selectedSourceId === source.id ? styles.active : '')}
            onClick={() => onSelect(source.id)}
            type="button"
        >
            <img alt="logo" src={source.logo} width={16} height={16} />
            <p className="ml-2 text-[14px]">
                {source.name}
                {showExtraSymbol && <span className="text-yellow-400"> *</span>}
            </p>
        </button>
    );
};

export default TrafficButton;
